// extracted by mini-css-extract-plugin
export default {"inputBox":"customeSelectBox_styles_inputBox__XWzOp","requiredSing":"customeSelectBox_styles_requiredSing__AmRyn","error":"customeSelectBox_styles_error__zWDkO"};